export default __webpack_public_path__ + "static/media/stone3.fd59dc3d.png";